import { EstateType } from "@1games-ru/region-shared/dist/enums/estate/estate";
import { EstateRelatedDto } from "@1games-ru/region-shared/dist/types/estate/estate";
import clsx from "clsx";
import { StarIcon } from "@/shared/icons";
import getEstateImage from "@/domains/estate/helpers/getEstateImage";
import PlayerMenuCharacterDataCard from "@/domains/playerMenu/components/character/data/PlayerMenuCharacterDataCard";

export default function PlayerMenuCharacterEstateCard(estate: EstateRelatedDto) {
  const { address, entity } = estate;
  const estateImage = estate?.id
    ? getEstateImage(
        {
          id: estate?.id,
          type: entity.type,
          complexId: entity.type === EstateType.Apartment ? entity.content.complexId : null,
        },
        "medium",
      )
    : ""; // TODO: вынести в другое место, и не лезть в другой модуль

  return (
    <PlayerMenuCharacterDataCard className="relative">
      <img
        // src="https://hips.hearstapps.com/hmg-prod/images/west-virginia-gray-cottage-64dd6bb056057.jpg?crop=0.943xw:0.817xh;0.0224xw,0.0932xh&resize=980:*" // TODO: estateImage
        src={estateImage}
        className="absolute top-0 left-0 right-0 grayscale opacity-5 pointer-events-none"
        alt=""
      />
      <div className="flex flex-col w-full h-full">
        <div
          className={clsx(
            "h-[1.5rem] w-fit px-1 flex items-center gap-1 bg-white rounded-[0.375rem]",
            " text-dark-900 text-[0.75rem] font-bold leading-[0.75rem] uppercase",
          )}
        >
          <StarIcon size={14} />
          {estate?.level || ""}
        </div>
        <div className="text-18 font-bold mt-3.5">Дом #{estate?.id || 0}</div>
        <div className="text-15 font-medium text-white/50">
          {address.streetName} {address.index}
        </div>

        <div className="mt-auto text-18 font-bold">Место жительства</div>
      </div>
    </PlayerMenuCharacterDataCard>
  );
}
